<template>
    <div class="col-12">
        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-10 col-lg-6">
                <div class="row text-center ml-5">
                    <div class="mb-5">
                        <img src="../../assets/tn_cybertech_grad_logo.png" class="tn-logo" style="width: 200px; height: auto;">
                    </div>
                    <p class="text-muted mt-4">Set your 4-digit PIN to secure your account.</p>
                </div>
                <div class="ui fitted divider mt-2"></div>
            </div>
        </div>
        <div class="row d-flex justify-content-center align-items-center mt-5">
            <div class="col-11 col-lg-10">
                <form class="ui form" v-bind:class="{ 'loading': isBusy() }" @submit.prevent="submitPasswordForm">
                    <div class="card-body">
                        <h4 class="ui dividing header">Set PIN</h4>
                        <div class="field">
                            <label>PIN</label>
                            <input type="password" v-model="customer.password" placeholder="Enter 4-digit PIN" maxlength="4" inputmode="numeric" pattern="[0-9]*">
                            <small v-if="!isPasswordValid" class="text-danger mt-1">
                                PIN must be exactly 4 digits
                            </small>
                        </div>
                        <div class="field">
                            <label>Confirm PIN</label>
                            <input type="password" v-model="customer.confirmPassword" placeholder="Confirm 4-digit PIN" maxlength="4" inputmode="numeric" pattern="[0-9]*">
                            <small v-if="!isConfirmPasswordValid" class="text-danger mt-1">
                                PINs do not match
                            </small>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="ui button purple fluid mt-4" :disabled="!isPasswordFormValid">
                            Submit PIN
                        </button>
                        <button class="ui large basic button black fluid mt-4 mb-4" @click="back">Back</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import baseMethods from "@/utils/baseMethods";
import { Notify } from "@/utils/notifications";
import { useAuthStore } from '@/stores/auth';
import { useCustomerStore } from '@/stores/customer';

export default {
    name: "Password",
    setup() {
        const authStore = useAuthStore();
        const customerStore = useCustomerStore();
        return { authStore, customerStore };
    },
    data() {
        return {
            customer: {
                mobileNumber: '',
                phone: '',
                title: "",
                firstName: '',
                lastName: '',
                identityDocNo: '',
                email: '',
                gotCustomerData: false,
                requestType: "REGISTRATION",
                dateOfBirth: null,
                country: "",
                password: "",
                pin: "",
                confirmPassword: "",
                channel: "MOBILE",
                idNoType: "national-id",
                idNo: '',
                uuid: '',
                provider: "CHANNEL",
                action: "LOGIN",
                imei: "abcde",
                street: "",
            },
            errors: {},
            operations: 0,
        };
    },
    computed: {
        storePhone() { return this.authStore.phone; },
        storeUuid() { return this.authStore.uuid; },
        storeFirstName() { return this.customerStore.firstName; },
        storeLastName() { return this.customerStore.lastName; },
        storeIdentityDocNo() { return this.customerStore.identityDocNo; },
        storeEmail() { return this.customerStore.email; },
        isPasswordValid() {
            return /^[0-9]{4}$/.test(this.customer.password);
        },
        isConfirmPasswordValid() {
            return this.customer.password === this.customer.confirmPassword;
        },
        isPasswordFormValid() {
            return this.isPasswordValid && this.isConfirmPasswordValid;
        },
    },
    created() {
        // Initialize customer data from Vuex store
        this.customer.mobileNumber = this.storePhone;
        this.customer.phone = this.storePhone;
        this.customer.firstName = this.storeFirstName;
        this.customer.lastName = this.storeLastName;
        this.customer.identityDocNo = this.storeIdentityDocNo;
        this.customer.email = this.storeEmail;
        this.customer.idNo = this.storeIdentityDocNo;
        this.customer.uuid = this.storeUuid;
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        submitPasswordForm() {
            if (this.isPasswordFormValid) {
                // SECURITY: Never store passwords in localStorage or Vuex
                // Password is only used for this request and discarded

                this.customer.pin = this.customer.password;
                this.customer.name = this.customer.firstName;

                console.log(this.customer);
                this.post_auth_no_auth('/authentication', this.customer, "Successful").then((res) => {
                    console.log(res);
                    if (res && res.success && res.body.accessToken) {
                        // Store auth data
                        this.login({
                            accessToken: res.body.accessToken,
                            user: {
                                id: res.body.userId,
                                name: res.body.name,
                                full_name: `${res.body.name} ${res.body.lastName}`,
                                email: res.body.email,
                                idNo: res.body.idNo,
                                idNoType: res.body.idNoType,
                            },
                        });
                        this.setPhone(res.body.phone);
                        this.setEmail(res.body.email);
                        this.$router.push("/omni/upload-documents");
                    } else if (res) {
                        Notify.fire("Error", res.message || "Registration failed. Please try again.", "error");
                    } else {
                        Notify.fire("Error", "Registration failed. Please try again.", "error");
                    }
                }).catch(error => {
                    console.error("Error during registration:", error);
                    Notify.fire("Error", "Registration failed. Please try again.", "error");
                });
            }
        },
        login(data) { this.authStore.login(data); },
        setPhone(phone) { this.authStore.setPhone(phone); },
        setEmail(email) { this.authStore.setEmail(email); },
        ...baseMethods,
    }
}
</script>
